export default __webpack_public_path__ + "atomic/_patterns/02-molecules/search-result/_search-result.twig";